/**
 * NOT CHECKED
 */
import React from 'react';

import { checkIsAnyNotLoaded } from '@utils/loadingChecks';

import './Loader.scss';

/* Default marker so ui-automation-tests can wait for every page / block spinner to go away.
   Infinite-scroll "load more" markers pass testId="loader-more": they stay mounted while
   hasNextPage is true, so they must not count as a page that is still loading. */
const LOADER_TEST_ID = 'loader';

const Loader = ({
  children = null,
  isLoading = false,
  isFullScreenLoading = false,
  isFullBlockLoading = false,
  withTopMargin = false,
  lsDeps = [],
  backgroundColor = '#ffffff',
  color = '#221CB6',
  style = {},
  testId = LOADER_TEST_ID,
}) => {
  if (lsDeps.length > 0) {
    if (checkIsAnyNotLoaded(...lsDeps) || isLoading) {
      return (
        <div
          // @ts-ignore
          style={{ '--background-color': backgroundColor, '--loader-color': color, ...style }}
          className={`loader ${withTopMargin ? 'loader--with-top-margin' : ''}`}
          data-testid={testId}
        />
      );
    }
  }

  if (isLoading) {
    return (
      <div
        // @ts-ignore
        style={{ '--background-color': backgroundColor, '--loader-color': color, ...style }}
        className={`loader ${withTopMargin ? 'loader--with-top-margin' : ''}`}
        data-testid={testId}
      />
    );
  }

  if (isFullScreenLoading) {
    return (
      <div className="loader__full-screen-wrapper">
        <div
          // @ts-ignore
          style={{ '--background-color': backgroundColor, '--loader-color': color, ...style }}
          className="loader"
          data-testid={testId}
        />
      </div>
    );
  }

  if (isFullBlockLoading) {
    return (
      <div className="loader__full-block-wrapper">
        <div
          // @ts-ignore
          style={{ '--background-color': backgroundColor, '--loader-color': color, ...style }}
          className="loader"
          data-testid={testId}
        />
      </div>
    );
  }

  if (children) {
    return children;
  }

  return null;
};

export default Loader;
